import { useHydrated } from "@frend-digital/ui/hooks";
import { useCallback } from "react";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface GeoPopupState {
	dismissedGeoPopup: string | null;
	setDismissedGeoPopup: (hash: string | null) => void;
}

export const useGeoPopupStore = create<GeoPopupState>()(
	persist(
		(set) => ({
			dismissedGeoPopup: null,
			setDismissedGeoPopup: (dismissedGeoPopup) => set({ dismissedGeoPopup }),
		}),
		{
			name: "geo-popup-store",
			storage: createJSONStorage(() => sessionStorage),
		},
	),
);

export const useGeoPopup = ({
	centraCountry,
	selectedCountry,
}: {
	centraCountry: string;
	selectedCountry: string;
}) => {
	const { dismissedGeoPopup, setDismissedGeoPopup } = useGeoPopupStore();
	const currentGeoPopup = JSON.stringify({
		selectedCountry,
		centraCountry,
	});

	const isHydrated = useHydrated();

	const isVisible = isHydrated && dismissedGeoPopup !== currentGeoPopup;

	const dismiss = useCallback(() => {
		setDismissedGeoPopup(currentGeoPopup);
	}, [currentGeoPopup, setDismissedGeoPopup]);

	return {
		isVisible,
		dismiss,
	};
};
